import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * Composable for getters
 * Usage in Composition API:
 * 
 * import { useGetters } from '@/composables/getters';
 * 
 * export default {
 *   setup() {
 *     const { canChangeLoyaltyStatus, canEnrollLoyalty, canViewLoyalty, getBreadcrumbDetails, getCanUpdateBreadcrumb, getColorBubbles, getCurrentCartTypes, getCurrentHolHolidays, getCurrentShoppingLists, getDdbDeliveryDate, getDynamicBreadcrumb, getHgsDeliveryDate, getHolDeliveryDate, getMmtDeliveryDate, getSblDeliveryDate, getShopDeliveryDate, getShopMegaMenu, getSpecialsDeliveryDate, getWishListItems, isEnrolledLoyalty, isESales, isLoggedIn, isLoggingOut, isSalesRep, loggedinUserDetails, quoteDetails, quoteItemCount, wishListCount } = useGetters();
 *     return { canChangeLoyaltyStatus, canEnrollLoyalty, canViewLoyalty, getBreadcrumbDetails, getCanUpdateBreadcrumb, getColorBubbles, getCurrentCartTypes, getCurrentHolHolidays, getCurrentShoppingLists, getDdbDeliveryDate, getDynamicBreadcrumb, getHgsDeliveryDate, getHolDeliveryDate, getMmtDeliveryDate, getSblDeliveryDate, getShopDeliveryDate, getShopMegaMenu, getSpecialsDeliveryDate, getWishListItems, isEnrolledLoyalty, isESales, isLoggedIn, isLoggingOut, isSalesRep, loggedinUserDetails, quoteDetails, quoteItemCount, wishListCount };
 *   }
 * }
 */
export function useGetters() {
    const store = useStore();
    
    const canChangeLoyaltyStatus = computed(() => store.getters.canChangeLoyaltyStatus);
    const canEnrollLoyalty = computed(() => store.getters.canEnrollLoyalty);
    const canViewLoyalty = computed(() => store.getters.canViewLoyalty);
    const getBreadcrumbDetails = computed(() => store.getters.getBreadcrumbDetails);
    const getCanUpdateBreadcrumb = computed(() => store.getters.getCanUpdateBreadcrumb);
    const getColorBubbles = computed(() => store.getters.getColorBubbles);
    const getCurrentCartTypes = computed(() => store.getters.getCurrentCartTypes);
    const getCurrentHolHolidays = computed(() => store.getters.getCurrentHolHolidays);
    const getCurrentShoppingLists = computed(() => store.getters.getCurrentShoppingLists);
    const getDdbDeliveryDate = computed(() => store.getters.getDdbDeliveryDate);
    const getDynamicBreadcrumb = computed(() => store.getters.getDynamicBreadcrumb);
    const getHgsDeliveryDate = computed(() => store.getters.getHgsDeliveryDate);
    const getHolDeliveryDate = computed(() => store.getters.getHolDeliveryDate);
    const getLastReferrerRoute = computed(() => store.getters.getLastReferrerRoute);
    const getMmtDeliveryDate = computed(() => store.getters.getMmtDeliveryDate);
    const getSblDeliveryDate = computed(() => store.getters.getSblDeliveryDate);
    const getShopDeliveryDate = computed(() => store.getters.getShopDeliveryDate);
    const getShopMegaMenu = computed(() => store.getters.getShopMegaMenu);  
    const getSpecialsDeliveryDate = computed(() => store.getters.getSpecialsDeliveryDate);
    const getWishListItems = computed(() => store.getters.getWishListItems);
    const isEnrolledLoyalty = computed(() => store.getters.isEnrolledLoyalty);
    const isESales = computed(() => store.getters.isESales);
    const isLoggedIn = computed(() => store.getters.isLoggedIn);
    const isLoggingOut = computed(() => store.getters.isLoggingOut);
    const isSalesRep = computed(() => store.getters.isSalesRep);
    const loggedinUserDetails = computed(() => store.getters.loggedinUserDetails);
    const quoteDetails = computed(() => store.getters.quoteDetails);
    const quoteItemCount = computed(() => store.getters.quoteItemCount);
    const wishListCount = computed(() => store.getters.wishListCount);
    
    return {
        canChangeLoyaltyStatus,
        canEnrollLoyalty,
        canViewLoyalty,
        getBreadcrumbDetails,
        getCanUpdateBreadcrumb,
        getColorBubbles,
        getCurrentCartTypes,
        getCurrentHolHolidays,
        getCurrentShoppingLists,
        getDdbDeliveryDate,
        getDynamicBreadcrumb,
        getHgsDeliveryDate,
        getHolDeliveryDate,
        getLastReferrerRoute,
        getMmtDeliveryDate,
        getSblDeliveryDate,
        getShopDeliveryDate,
        getShopMegaMenu,
        getSpecialsDeliveryDate,
        getWishListItems,
        isEnrolledLoyalty,
        isESales,
        isLoggedIn,
        isLoggingOut,
        isSalesRep,
        loggedinUserDetails,
        quoteDetails,
        quoteItemCount,
        wishListCount,
    };
}